export default {"src":"/uk/_next/static/media/trust-pilot-logo.71170fc5.svg","height":376,"width":1533,"blurWidth":0,"blurHeight":0};